export const useComposable = () => {
    //* 获取I18n
    const i18n = useI18n();

    //* 响应式变量
    const refs = {
        key: ref<number>(0),
    };

    //* 配置项
    const options = [
        {
            name: i18n.t("MutationAnalysisTools"),
            children: [
                {
                    tag: i18n.t("AITool"),
                    img: "https://rdgta.cdn.cyagen.com/rddc/pictures/41a5fdf1-feac-43f3-a669-67d59f0e88c7.webp",
                    name: i18n.t("RNASplicer"),
                    label: "RNA Splicer",
                    route: { name: "RnaSplicer" },
                    descript: i18n.t("RNASplicerDescribe"),
                },
                {
                    tag: i18n.t("AITool"),
                    img: "https://rdgta.cdn.cyagen.com/rddc/pictures/514133b1-a90e-488d-a20d-2cebcf9b1110.webp",
                    name: i18n.t("VPP"),
                    label: "Pathogenicity Predictor",
                    route: { name: "Pathogenicity" },
                    descript: i18n.t("PathoPredictDescribe"),
                },
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/pictures/ff37deb8-0d5b-4b86-8742-fbefb2092a0d.webp",
                    name: i18n.t("MutationViewer"),
                    label: "Mutation Direct",
                    route: { name: "BioVariant" },
                    descript: i18n.t("MutationViewerDescribe"),
                },
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/pictures/635b8c29-808a-469b-bb54-100afd5207a5.webp",
                    name: i18n.t("SNPVisualization"),
                    label: "SNP Viewer",
                    route: { name: "DBSNP" },
                    descript: i18n.t("SNPVisualizationDescribe"),
                },
                {
                    tag: i18n.t("AITool"),
                    img: "https://rdgta.cdn.cyagen.com/rddc/pictures/88846f2f-dc41-48ea-9cb9-e6b9a282f8b7.webp",
                    name: i18n.t("MousePhenoPredict"),
                    label: "Mouse Pheno Predictor",
                    route: { name: "MousePhenoPredict" },
                    descript: i18n.t("MousePhenoPredictDescribe"),
                },
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/pictures/e2ed68eb-c2be-4000-bd26-63ffc908bce6.webp",
                    name: i18n.t("ASO"),
                    label: "ASO Designer",
                    route: { name: "ASOExperiment" },
                    descript: i18n.t("ASODescribe"),
                },
            ],
        },
        {
            name: i18n.t("SequenceAnalysisTools"),
            children: [
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/pictures/049d333c-f28d-4775-b2da-50d0ad0fb433.webp",
                    name: i18n.t("SequenceAlignment"),
                    label: "Sequence Alignment",
                    route: { name: "SequenceAlignment" },
                    descript: i18n.t("SequenceAlignmentDescribe"),
                },
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/pictures/648334fa-e885-42ab-b4f9-d6237489b89e.webp",
                    name: i18n.t("SequenceViewer"),
                    label: "Sequence Viewer",
                    route: { name: "BioSequence" },
                    descript: i18n.t("SequenceViewerDescribe"),
                },
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/pictures/d6c769a9-dee6-47f0-bcc0-019c0370a0a1.webp",
                    name: i18n.t("AAAbbreviationConverter"),
                    label: "Amino Acid Abbreviation Converter",
                    route: { name: "AbbreviationConverter" },
                    descript: i18n.t("AAAbbreviationConverterDescribe"),
                },
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/pictures/3872d2a6-62e6-47f1-9c52-8c3147d4254d.webp",
                    name: i18n.t("SequenceProcessor"),
                    label: "Sequence Processor",
                    route: { name: "SequenceProcessor" },
                    descript: i18n.t("SequenceProcessorToolDescript"),
                },
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/pictures/9bf9e9bf-7f60-419b-96b9-adc6f87d3dab.webp",
                    name: i18n.t("BLAT"),
                    label: "BLAT",
                    route: { name: "BLAT" },
                    descript: i18n.t("BLATDescribe"),
                },
            ],
        },
        {
            name: i18n.t("ComparisonTools"),
            children: [
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/pictures/773528b9-27d7-428b-96d5-9effd05ca47a.webp",
                    name: i18n.t("GeneticComparison"),
                    label: "Gene Comparison",
                    route: { name: "GeneticComparison" },
                    descript: i18n.t("GeneticComparisonDescribe"),
                },
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/pictures/9fa562b9-9d06-4174-a75e-c573bfcfdb63.webp",
                    name: i18n.t("DiseasesComparison"),
                    label: "Disease Comparison",
                    route: { name: "DiseasesComparison" },
                    descript: i18n.t("DiseasesComparisonDescribe"),
                },
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/pictures/7ef7e6d3-53c6-4c45-b327-6566bb1ee687.webp",
                    name: i18n.t("ModelComparison"),
                    label: "Model Comparison",
                    route: { name: "ModelComparison" },
                    descript: i18n.t("ModelComparisonDescribe"),
                },
            ],
        },
        {
            name: i18n.t("OtherTools"),
            children: [
                {
                    tag: i18n.t("AITool"),
                    img: "https://rdgta.cdn.cyagen.com/rddc/pictures/f7267cb1-1344-44ba-bf12-689522362eed.webp",
                    name: i18n.t("AIAgent"),
                    label: "AI Assistant",
                    route: { name: "Chatagent" },
                    descript: i18n.t("AIAgentDescribe"),
                },
                {
                    tag: i18n.t("AITool"),
                    img: "https://rdgta.cdn.cyagen.com/rddc/pictures/83aeb0e9-aef5-4a72-a1c1-9f6b6c631e76.webp",
                    name: i18n.t("MTH"),
                    label: "Homolog Predictor",
                    route: { name: "MTH" },
                    descript: i18n.t("MTHDesc"),
                },
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/pictures/6e01307d-1186-4516-838f-b7c23b3a2afa.webp",
                    name: i18n.t("PathwayAnalysis"),
                    label: "Pathway Enrichment Analysis",
                    route: { name: "SignalPath" },
                    descript: i18n.t("PathwayAnalysisDescribe"),
                },
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/pictures/ddafd0ae-f4e6-431f-be8a-2cd03ace689f.webp",
                    name: i18n.t("EnsemblNCBI"),
                    route: { name: "TransformID" },
                    label: "Ensembl-NCBI Converter",
                    descript: i18n.t("EnsemblNCBIDescribe"),
                },
                {
                    tag: i18n.t("AITool"),
                    img: "https://rdgta.cdn.cyagen.com/rddc/pictures/888adb8d-e98e-4adc-bdbc-29d5f0ff0ca0.webp",
                    name: i18n.t("SingleCellAtlas"),
                    label: "Gene Expression Database",
                    route: "/sca",
                    descript: i18n.t("SingleCellAtlasDescribe"),
                },
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/pictures/9f5cc8a6-655c-47c9-9f61-8aa5111d9726.webp",
                    name: i18n.t("CancerBiomarkersLibrary"),
                    label: "Cancer Target Database",
                    route: { name: "CBL" },
                    descript: i18n.t("CancerBiomarkersLibraryDescribe"),
                },
                {
                    tag: i18n.t("AITool"),
                    img: "https://rdgta.cdn.cyagen.com/rddc/pictures/df29b2d8-2120-42ea-90f9-75c4b4f77526.webp",
                    name: i18n.t("DGPrediction"),
                    label: "Affinity Predictor",
                    route: { name: "DGPrediction" },
                    descript: i18n.t("DGPredictionDesc1"),
                },
                {
                    tag: i18n.t("AITool"),
                    img: "https://rdgta.cdn.cyagen.com/rddc/images/tool/aav.webp",
                    name: i18n.t("AAVCapsidViability"),
                    label: "AAV Capsid Viability Predictor",
                    route: { name: "AAVViability" },
                    descript: i18n.t("AAVCapsidViabilityDescript"),
                },
            ],
        },
    ];

    const methods = {
        navigate: (index: number) => {
            const node = document.querySelectorAll(".tools-container")[index] as HTMLElement;

            //* 触发滚动
            if (node) scrollTo({ top: (node.offsetTop || 0) - 20, behavior: "smooth" });
        },
        handler: () => {
            //* 通过页面滚动距离计算当前导航索引
            document.querySelectorAll(".tools-container")?.forEach((value, index) => {
                const rect = value.getBoundingClientRect();
                if (rect.top >= 0 && rect.top <= innerHeight * 0.3 && rect.bottom >= 0) {
                    //* 索引更新
                    refs.key.value = index;
                }
            });
        },
    };

    return { refs, options, methods };
};
